import { Alert } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface WorkflowContentProps {
  showValidationWarning: boolean;
  alertAriaLabel?: string;
  warningPosition?: 'top' | 'bottom';
  warningMessage?: string;
}

const Warning = ({
  warningMessage,
  alertAriaLabel,
}: Pick<WorkflowContentProps, 'warningMessage' | 'alertAriaLabel'>) => {
  const { t } = useTranslation('campaigns');
  return (
    <Alert
      heading={warningMessage ?? t('onsite.editor.workflow.workflowAlertIncompleteHeading')}
      variation="warning"
      mini
      aria-label={alertAriaLabel}
    >
      {warningMessage ? null : t('onsite.editor.workflow.workflowAlertIncompleteBody')}
    </Alert>
  );
};

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing4};
`;

export const WorkflowContent = ({
  children,
  showValidationWarning,
  alertAriaLabel,
  warningPosition = 'bottom',
  warningMessage,
}: PropsWithChildren<WorkflowContentProps>) => {
  if (showValidationWarning) {
    return (
      <ContentContainer>
        {warningPosition === 'top' ? <Warning alertAriaLabel={alertAriaLabel} warningMessage={warningMessage} /> : null}
        <div>{children}</div>
        {warningPosition === 'bottom' ? (
          <Warning alertAriaLabel={alertAriaLabel} warningMessage={warningMessage} />
        ) : null}
      </ContentContainer>
    );
  }

  return <>{children}</>;
};
